import React, { Component } from "react";
import { Button, Col, Label, Row, Input, Alert as Alert2 } from "reactstrap";
import Select from "react-select";
import Alert from "react-s-alert";
import DefaultModal from "../../invoice/DefaultModal";
import { ACCESS_TOKEN, EntegratorConf } from "../../../constants";
import { request } from "../../../helper/APIUtils";
import { showAxiosError } from "../../../helper/helper";
import { EntegratorIdentifiers } from "../../../helper/enums";
import { Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle } from 'react-accessible-accordion';
import moment from "moment";

class CustomerRequestModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            requestMessage: {},
            saveLoading: false,
            selectedTopic: "",
            selectedCategory: "",
            selectedRequestType: "",
            explanation: "",
            files: [],
            categories: [],
            requestTypes: [
                { value: "Destek", label: "Destek" },
                { value: "Bilgi Alma", label: "Bilgi Alma" },
                { value: "Öneri", label: "Öneri" }
            ],
            trackingRequests: [],
            messagesByRequest: {},
            loadingMessages: {}
        };

        this.topics = [
            "E-Dönüşüm",
            "KolaysoftPOS",
            "EczacıPOS",
            // "PEYK",
            "Konnektör"
        ].filter(topic => !(EntegratorIdentifiers.SMART === EntegratorConf.identifier && topic === "EczacıPOS"));
    }

    componentDidMount() {
        this.fetchTrackingRequests();
    }

    fetchTrackingRequests() {
        const { customer } = this.props;
        const url = `https://crm.kolaysoft.com.tr/api/request/requests-by-vknTckn?vknTckn=${customer.vknTckn}`;
        request({
            url: url,
            method: "get"
        })
            .then(response => {
                if (response.data && response.data.length > 0) {
                    this.setState({ trackingRequests: response.data }, () => {
                        this.state.trackingRequests.forEach(item => {
                            this.fetchMessagesForRequest(item.requestNo);
                        });
                    });
                }
            })
            .catch(error => {
                showAxiosError(error);
            });
    }

    fetchMessagesForRequest(requestNo) {
        this.setState(prevState => ({
            loadingMessages: { ...prevState.loadingMessages, [requestNo]: true }
        }));
        request({
            url: `https://crm.kolaysoft.com.tr/api/message/messages-by-requestNo?requestNo=${requestNo}`,
            method: "get"
        })
            .then(response => {
                this.setState(prevState => ({
                    messagesByRequest: {
                        ...prevState.messagesByRequest,
                        [requestNo]: response.data
                    },
                    loadingMessages: {
                        ...prevState.loadingMessages,
                        [requestNo]: false
                    }
                }));
            })
            .catch(error => {
                showAxiosError(error);
                this.setState(prevState => ({
                    loadingMessages: { ...prevState.loadingMessages, [requestNo]: false }
                }));
            });
    }

    downloadFile = async (recordId, originalFileName) => {
        try {
            const response = await fetch(`https://crm.kolaysoft.com.tr/api/message/download-file-from-path?recordId=${recordId}`, {
                method: "POST"
            });

            if (!response.ok) {
                throw new Error(`Dosya indirme hatası. Sunucu kodu: ${response.status}`);
            }

            const blob = await response.blob();

            let filename = originalFileName || "downloaded_file";
            const contentDisposition = response.headers.get("Content-Disposition");
            if (contentDisposition && contentDisposition.indexOf("filename=") !== -1) {
                const match = contentDisposition.match(/filename="?(.+)"?/);
                if (match && match[1]) {
                    filename = match[1];
                }
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            Alert.error("Dosya indirilemedi: " + error.message, {
                position: "top-right",
                effect: "stackslide",
                timeout: 3000
            });
        }
    };

    handleTopicChange = (selectedTopic) => {
        this.setState({
            selectedTopic,
            selectedCategory: "",
            selectedRequestType: "",
            categories: []
        }, () => {
            if (this.state.selectedTopic === "E-Dönüşüm") {
                this.fetchCategoriesFromBackend();
            }
        });
    };

    fetchCategoriesFromBackend() {
        let self = this;
        let customerId = this.props.customer.recordId;
        let params = {
            url: `/signature/alias/getServicesByCustomerId?customerId=${customerId}`,
            method: "get"
        };
        request(params)
            .then(function(response) {
                let categoriesData = response.data;
                let categories = categoriesData.map(cat => ({ value: cat, label: cat }));
                self.setState({ categories: categories });
            })
            .catch(function(error) {
                if (error.response === undefined) {
                    showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
                } else {
                    let enc = new TextDecoder("utf-8");
                    showAxiosError({message: enc.decode(error.response.data)});
                }
            });
    }

    handleCategoryChange = (selectedCategory) => {
        this.setState({
            selectedCategory,
            selectedRequestType: ""
        });
    };

    getCategoryOptions = (selectedTopic) => {
        if (selectedTopic === "KolaysoftPOS" || selectedTopic === "EczacıPOS") {
            return [
                { value: "Başvuru", label: "Başvuru" },
                { value: "Kurulum", label: "Kurulum" },
                { value: "Tanıtım", label: "Tanıtım" },
                { value: "Güncelleme", label: "Güncelleme" },
                { value: "Kargo Durumu", label: "Kargo Durumu" },
                { value: "BKM Onayı", label: "BKM Onayı" },
                { value: "POSAsistan Kurulumu", label: "POSAsistan Kurulumu" },
                { value: "POSAsistan Hatası", label: "POSAsistan Hatası" },
                { value: "Yeni Talep", label: "Yeni Talep" }
            ];
        } else if (selectedTopic === "PEYK") {
            return [
                { value: "Şifre Yenileme", label: "Şifre Yenileme" },
                { value: "Bilgi", label: "Bilgi" }
            ];
        } else if (selectedTopic === "Konnektör") {
            return [
                { value: "Belge Getirmeme", label: "Belge Getirmeme" },
                { value: "Hatalı Getirmesi", label: "Hatalı Getirmesi" },
                { value: "Yeni Talep", label: "Yeni Talep" }
            ];
        } else if (selectedTopic === "E-Dönüşüm") {
            return this.state.categories;
        }
        return [];
    };

    getRequestTypeOptions = (selectedTopic, selectedCategory) => {
        if (selectedTopic === "E-Dönüşüm" && (selectedCategory?.value === "E-Fatura" || selectedCategory?.value === "E-Arsiv")) {
            return [
                { value: "Gönderim Hatası", label: "Gönderim Hatası" },
                { value: "Aktivasyon Etiket Hatası", label: "Aktivasyon Etiket Hatası" },
                { value: "İndirme-Yazdırma Hatası", label: "İndirme-Yazdırma Hatası" },
                { value: "Transfer Fatura Hatası", label: "Transfer Fatura Hatası" },
                { value: "E-Posta Gönderim Hatası", label: "E-Posta Gönderim Hatası" },
                ...this.state.requestTypes
            ];
        }
        return this.state.requestTypes;
    };

    handleRequestTypeChange = (selectedRequestType) => {
        this.setState({
            selectedRequestType
        });
    };

    handleInputChange = (field, value) => {
        this.setState({ [field]: value });
    };

    handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const validTypes = [
            "image/jpeg",
            "image/png",
            "application/pdf",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ];

        const invalidFiles = selectedFiles.filter(file => !validTypes.includes(file.type));
        if (invalidFiles.length > 0) {
            Alert.error("Yalnızca JPEG, PNG, PDF veya Excel dosyaları yüklenebilir.", {
                position: "top-right",
                effect: "stackslide",
                timeout: 3000,
            });
            return;
        }
        this.setState({ files: selectedFiles });
    };

    sendRequestMessage = async (e) => {
        e.preventDefault();
        this.setState({ saveLoading: true });
        const { selectedTopic, selectedCategory, selectedRequestType, explanation, files } = this.state;

        if (!selectedTopic) {
            Alert.error("Lütfen Konu seçimini yapınız.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            this.setState({ saveLoading: false });
            return;
        }
        if (!selectedCategory) {
            Alert.error("Kategori alanı seçimi zorunludur.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            this.setState({ saveLoading: false });
            return;
        }
        if (selectedTopic === "E-Dönüşüm" && !selectedRequestType) {
            Alert.error("Lütfen Talep Tipini seçiniz.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            this.setState({ saveLoading: false });
            return;
        }
        if (!explanation) {
            Alert.error("Açıklama alanı boş bırakılamaz.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            this.setState({ saveLoading: false });
            return;
        }
        /*if (phone && phone.length > 0 && phone.length < 10) {
            Alert.error("Geçersiz telefon numarası. Lütfen 10 haneli bir telefon numarası girin.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            return;
        }*/

        const { customer } = this.props;
        const vknTckn = customer.vknTckn;
        const requestTitle = customer.formattedName || customer.title;
        const phone = customer.sorumluCepTel;
        const email = customer.corporateMail;
        const distributorName = customer.distributorName;

        const idToken = localStorage.getItem(ACCESS_TOKEN);
        if (!idToken) {
            Alert.error("Token bulunamadı. Lütfen tekrar giriş yapınız.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            this.setState({ saveLoading: false });
            return;
        }

        const requestCreateDto = {
            topic: selectedTopic,
            category: selectedCategory.value,
            requestType: selectedRequestType ? selectedRequestType.value : "",
            explanation: explanation,
            phone: phone,
            email: email,
            vknTckn: vknTckn,
            requestTitle: requestTitle,
            distributorName: distributorName
        };

        const formData = new FormData();
        formData.append("data", new Blob([JSON.stringify(requestCreateDto)], { type: "application/json" }));
        // formData.append("files", new Blob());
        formData.append("jwtToken", localStorage.getItem(ACCESS_TOKEN));
        files.forEach(file => formData.append("files", file));

        const params = {
            url: "/requestmessage/sendRequestToCRM",
            method: "POST",
            data: formData,
        };

        try {
            await request(params);
            Alert.success("Talebiniz oluşturulmuştur.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });

            this.props.onClose();

            this.setState({
                selectedTopic: "",
                selectedCategory: "",
                selectedRequestType: "",
                explanation: "",
                phone: "",
                email: "",
                requestMessage: null,
                files: []
            });
        } catch (error) {
            Alert.error("Hata oluştu: " + error.message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
        } finally {
            this.setState({ saveLoading: false });
        }
    };

    render() {
        const {
            selectedTopic,
            selectedCategory,
            selectedRequestType,
            explanation,
            trackingRequests,
            messagesByRequest
        } = this.state;

        return (
            <DefaultModal
                disabled={this.state.saveLoading}
                isOpen={this.props.modal}
                title={`Talep Oluştur - ${this.props.customer.vknTckn}`}
                size="lg"
                confirmBtnText="Gönder"
                cancelBtnText="Kapat"
                onCancel={this.props.onClose}
                onConfirm={this.sendRequestMessage}
                confirmDisabled={this.state.saveLoading}
            >
                <Col sm="12">
                    <Col sm="12" style={{ border: "2px solid #e7e7e7", borderRadius: "6px" }}>
                        <Row style={{ paddingTop: "10px" }}>
                            <Col sm="12" lg="3">
                                <Label>Konu:</Label>
                                <Select
                                    isClearable={false}
                                    placeholder="Konu Seçiniz.."
                                    value={selectedTopic ? { label: selectedTopic, value: selectedTopic } : null}
                                    onChange={(option) => this.handleTopicChange(option ? option.value : "")}
                                    options={this.topics.map(topic => ({ value: topic, label: topic }))}
                                />
                            </Col>
                            <Col sm="12" lg="3">
                                <Label>Kategori:</Label>
                                <Select
                                    isClearable={false}
                                    value={selectedCategory}
                                    placeholder="Kategori Seçiniz.."
                                    onChange={(option) => this.handleCategoryChange(option)}
                                    options={this.getCategoryOptions(selectedTopic)}
                                    isDisabled={!selectedTopic}
                                />
                            </Col>
                            {selectedTopic === "E-Dönüşüm" && (
                                <Col sm="12" lg="3">
                                    <Label>Talep Tipi:</Label>
                                    <Select
                                        isClearable={false}
                                        placeholder="Talep Seçiniz.."
                                        value={selectedRequestType}
                                        onChange={(option) => this.handleRequestTypeChange(option)}
                                        options={this.getRequestTypeOptions(selectedTopic, selectedCategory)}
                                        isDisabled={!selectedCategory}
                                    />
                                </Col>
                            )}
                            <Col sm="12" style={{ paddingTop: "10px" }}>
                                <Label>Açıklama:</Label>
                                <textarea
                                    rows="4"
                                    value={explanation}
                                    style={{ width: '100%', paddingBottom: 'inherit' }}
                                    onChange={(e) => this.handleInputChange("explanation", e.target.value)}
                                />
                            </Col>
                            <Col sm="12" style={{ marginTop: "10px" }}>
                                <Label>Dosya Ekle:</Label>
                                <Input
                                    type="file"
                                    multiple
                                    onChange={this.handleFileChange}
                                    accept=".jpeg,.jpg,.png,.pdf,.xls,.xlsx"
                                />
                            </Col>
                            {/*<Col sm="12" lg="3" style={{ paddingTop: "10px" }}>
                                <Label>Telefon Numarası:</Label>
                                <Input
                                    type="text"
                                    value={`+90${phone}`}
                                    maxLength={13}
                                    onChange={(e) => {
                                        let inputValue = e.target.value;

                                        if (!inputValue.startsWith("+90")) {
                                            inputValue = `+90${phone}`;
                                        } else {
                                            const numberWithoutPrefix = inputValue.slice(3).replace(/\D/g, '');
                                            if (numberWithoutPrefix.length <= 10) {
                                                this.handleInputChange("phone", numberWithoutPrefix);
                                            }
                                        }
                                    }}
                                />
                            </Col>*/}
                            {/*<Col sm="12" lg="5" style={{ paddingTop: "10px" }}>
                                <Label>eMail:</Label>
                                <Input
                                    type="email"
                                    placeholder="eposta@mail.com"
                                    value={email}
                                    onChange={(e) => this.handleInputChange("email", e.target.value)}
                                />
                            </Col>*/}
                        </Row>
                    </Col>

                    {trackingRequests && trackingRequests.length > 0 && (
                        <Col sm="12" style={{ paddingBottom: "10px", marginTop: "10px", border: "2px solid #e7e7e7", borderRadius: "6px" }}>
                            <h5 style={{ marginLeft: "10px", marginTop: "10px", textTransform: "none" }}>Talep Takibi</h5>
                            <Accordion>
                                {[...trackingRequests]
                                    .sort((a, b) => new Date(a.createTime) - new Date(b.createTime))
                                    .map((item, index) => {
                                        const detail = messagesByRequest[item.requestNo];
                                        const sortedMsgs = Array.isArray(detail)
                                            ? [...detail].sort((a, b) => new Date(a.createTime) - new Date(b.createTime))
                                            : [];

                                        return (
                                            <AccordionItem key={`tracking-item-${index}`}>
                                                <AccordionItemTitle className="accordion__title">
                                                    <h6
                                                        className="u-position-relative"
                                                        style={{
                                                            margin: "0px",
                                                            marginLeft: "10px",
                                                            textTransform: "none",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between"
                                                        }}
                                                    >
                                                        <span>
                                                            {(index + 1) + ". " + item.requestNo + " - " + item.topic + " - " + item.category}
                                                        </span>
                                                        <span style={{ display: "flex", alignItems: "center" }}>
                                                            <span style={{ marginRight: "44px" }}>
                                                                {item.createTime ? moment(item.createTime).format("DD-MM-YYYY HH:mm") : ""}
                                                            </span>
                                                            <div className="accordion__arrow" role="presentation" />
                                                        </span>
                                                    </h6>
                                                </AccordionItemTitle>
                                                <AccordionItemBody>
                                                    {sortedMsgs.map((msg, msgIndex) => (
                                                        msg.messageType === "Mesaj" ? (
                                                            <Alert2
                                                                key={`msg-${msgIndex}`}
                                                                style={{
                                                                    backgroundColor: "#f8d7da",
                                                                    borderColor: "#f5c6cb",
                                                                    color: "#000000",
                                                                    padding: "8px"
                                                                }}
                                                            >
                                                                <h4 className="alert-heading">
                                                                    Mesaj: <span style={{ float: "right" }}>
                                                                        {msg.createTime ? moment(msg.createTime).format("DD-MM-YYYY HH:mm") : ""}
                                                                    </span>
                                                                </h4>
                                                                {msg.context}
                                                                {msg.messageFiles && msg.messageFiles.length > 0 && (
                                                                    <div style={{ marginTop: "8px" }}>
                                                                        {msg.messageFiles.map((file, fileIndex) => (
                                                                            <div
                                                                                key={`file-${fileIndex}`}
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                    alignItems: "center",
                                                                                    marginBottom: "4px"
                                                                                }}
                                                                            >
                                                                                <span style={{ color: "#000000" }}>
                                                                                    {file.originalFileName}
                                                                                </span>
                                                                                <span
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => this.downloadFile(file.recordId, file.originalFileName)}
                                                                                >
                                                                                    <i className="fa fa-download" style={{ color: "#000000" }} />
                                                                                </span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </Alert2>
                                                        ) : (
                                                            <Alert2
                                                                key={`msg-${msgIndex}`}
                                                                style={{
                                                                    backgroundColor: "#d4edda",
                                                                    borderColor: "#c3e6cb",
                                                                    color: "#000000",
                                                                    padding: "8px"
                                                                }}
                                                            >
                                                                <h4 className="alert-heading">
                                                                    Cevap: <span style={{ float: "right" }}>
                                                                        {msg.createTime ? moment(msg.createTime).format("DD-MM-YYYY HH:mm") : ""}
                                                                    </span>
                                                                </h4>
                                                                {msg.context}
                                                                {msg.messageFiles && msg.messageFiles.length > 0 && (
                                                                    <div style={{ marginTop: "8px" }}>
                                                                        {msg.messageFiles.map((file, fileIndex) => (
                                                                            <div
                                                                                key={`file-${fileIndex}`}
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                    alignItems: "center",
                                                                                    marginBottom: "4px"
                                                                                }}
                                                                            >
                                                                                <span style={{ color: "#000000" }}>
                                                                                    {file.originalFileName}
                                                                                </span>
                                                                                <span
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => this.downloadFile(file.recordId, file.originalFileName)}
                                                                                >
                                                                                    <i className="fa fa-download" style={{ color: "#000000" }} />
                                                                                </span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </Alert2>
                                                        )
                                                    ))}
                                                </AccordionItemBody>
                                            </AccordionItem>
                                        );
                                    })}
                            </Accordion>
                        </Col>
                    )}
                </Col>
            </DefaultModal>
        );
    }
}

export default CustomerRequestModal;
